const StatusData = [
    {
        label: 'InActive',
        value: 0,
    },
    {
        label: 'Active',
        value: 1,
    },
];

export default StatusData;